import { render, staticRenderFns } from "./RevenueExpensesContract.vue?vue&type=template&id=02123647&scoped=true"
import script from "./RevenueExpensesContract.vue?vue&type=script&lang=js"
export * from "./RevenueExpensesContract.vue?vue&type=script&lang=js"
import style0 from "./RevenueExpensesContract.vue?vue&type=style&index=0&id=02123647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02123647",
  null
  
)

export default component.exports